import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-acm-blue via-[#004e92] to-acm-blue flex items-center justify-center p-5">
      <div className="text-center bg-white/95 backdrop-blur-xl rounded-[30px] shadow-2xl p-12 max-w-[600px]">
        <h1 className="text-[150px] font-bold bg-gradient-to-r from-acm-purple via-acm-purple-dark to-acm-purple bg-clip-text text-transparent mb-5">
          404
        </h1>
        <h2 className="text-3xl font-bold text-gray-800 mb-4">
          Sayfa Bulunamadı
        </h2>
        <p className="text-lg text-gray-600 mb-8">
          Üzgünüz, böyle bir sayfa yok veya silinmiş olabilir.
        </p>
        <Link
          to="/"
          className="inline-block bg-gradient-to-br from-acm-purple to-acm-purple-dark text-white py-3 px-8 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-[1.05] active:scale-[0.98] transition-all duration-200"
        >
          Ana sayfaya geri dön
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
